@if (loading$ | async) {
  <div class="loading-container">
    <app-loading></app-loading>
  </div>
}

<div class="page-container">
  <div class="scootaverses-description">
    <div class="description-title">Scootaverses</div>
    <div class="description-text">
      <span>
        {{ homePageDescriptionText }}
      </span>
    </div>
  </div>
  <div
    class="scootaverse-container"
    infiniteScroll
    [infiniteScrollDistance]="2"
    [infiniteScrollThrottle]="100"
    (scrolled)="onScroll()"
    [scrollWindow]="false"
  >
    @if ((roomSets$ | async)?.length === 0 && (loading$ | async) === false) {
      <no-scootaverses-page></no-scootaverses-page>
    } @else {
      <div class="scootaverse-list">
        @for (set of roomSets$ | async; track set.socialRoomSetId) {
          <scootaverse-card
            [roomSet]="set"
            (triggerRefetch)="refetchScootaverses()"
            (triggerChangeName)="set.name = $event"
          ></scootaverse-card>
        }
        @if ((loading$ | async) === false) {
          <create-scootaverse></create-scootaverse>
        }
      </div>
    }
  </div>
</div>
